import api from './api';

const BASE = '/inspecciones';

// Misma clave de sesión quincenal que usa el backend
export const sesionActualModulo = () => {
    const ahora = new Date();
    const mes = String(ahora.getMonth() + 1).padStart(2, '0');
    const quincena = ahora.getDate() <= 15 ? 'Q1' : 'Q2';
    return `${ahora.getFullYear()}-${mes}-${quincena}`;
};

// Servicio genérico para los módulos MTTO/TI, que reutilizan el motor de
// "Inspecciones Quincenales" pero con preguntas propias (filtradas por `modulo`).
export const crearInspeccionModuloService = (modulo) => ({
    checklist: async (sesion = null) => {
        const params = { sesion: sesion || sesionActualModulo(), modulo };
        const response = await api.get(`${BASE}/checklist`, { params });
        return response.data;
    },

    listarPreguntas: async (soloActivas = true) => {
        const response = await api.get(`${BASE}/preguntas`, { params: { solo_activas: soloActivas, modulo } });
        return response.data;
    },

    crearPregunta: async (texto, descripcion = null, orden = 0) => {
        const response = await api.post(`${BASE}/preguntas`, { texto, descripcion, orden }, { params: { modulo } });
        return response.data;
    },

    actualizarPregunta: async (id, datos) => {
        const response = await api.put(`${BASE}/preguntas/${id}`, datos, { params: { modulo } });
        return response.data;
    },

    eliminarPregunta: async (id) => {
        const response = await api.delete(`${BASE}/preguntas/${id}`, { params: { modulo } });
        return response.data;
    },

    marcarOk: async (preguntaId, sesion = null) => {
        const params = { sesion: sesion || sesionActualModulo(), modulo };
        const response = await api.post(`${BASE}/preguntas/${preguntaId}/ok`, null, { params });
        return response.data;
    },

    responder: async (preguntaId, respuesta, estado = 'ok', sesion = null) => {
        const params = { respuesta, estado, sesion: sesion || sesionActualModulo(), modulo };
        const response = await api.post(`${BASE}/preguntas/${preguntaId}/responder`, null, { params });
        return response.data;
    },

    historial: async ({ anio = null, mes = null, dia = null } = {}) => {
        const params = { modulo };
        if (anio !== null && anio !== '') params.anio = anio;
        if (mes !== null && mes !== '') params.mes = mes;
        if (dia !== null && dia !== '') params.dia = dia;
        const response = await api.get(`${BASE}/historial`, { params });
        return response.data;
    },

    enviarReporte: async (email, sesion = null) => {
        const response = await api.post(`${BASE}/reporte/enviar`, {
            email,
            sesion: sesion || null,
            modulo,
        });
        return response.data;
    },

    descargarReportePDF: async (sesion = null) => {
        const response = await api.get(`${BASE}/reporte/descargar`, {
            params: { sesion: sesion || undefined, modulo },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], { type: 'application/pdf' }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `inspeccion_${modulo}_${sesion || 'actual'}.pdf`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    descargarReporteExcel: async (sesion = null) => {
        const response = await api.get(`${BASE}/reporte/descargar-excel`, {
            params: { sesion: sesion || undefined, modulo },
            responseType: 'blob',
        });
        const url = window.URL.createObjectURL(new Blob([response.data], {
            type: 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
        }));
        const link = document.createElement('a');
        link.href = url;
        link.setAttribute('download', `inspeccion_${modulo}_${sesion || 'actual'}.xlsx`);
        document.body.appendChild(link);
        link.click();
        link.remove();
        window.URL.revokeObjectURL(url);
    },

    // Sube el checklist (o el cronograma de frecuencias) del módulo desde un Excel,
    // reemplazando el checklist actual del módulo.
    importarChecklistExcel: async (file) => {
        const formData = new FormData();
        formData.append('file', file);
        const response = await api.post(`${BASE}/checklist/importar-excel`, formData, {
            headers: { 'Content-Type': 'multipart/form-data' },
            params: { modulo },
        });
        return response.data;
    },

    obtenerProgramacion: async () => {
        const response = await api.get(`${BASE}/programacion`, { params: { modulo } });
        return response.data;
    },
});
